import { MutationTree } from 'vuex';
import { LayoutStateInterface } from './state';

const mutation: MutationTree<LayoutStateInterface> = {
  setHideMobileToolbar(state: LayoutStateInterface, value: boolean) {
    state.hideMobileToolbar = value;
  },
}

export default mutation;